/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
//import Modal from "react-responsive-modal";

//import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
//import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import SettingItem from '../components/my/SettingItem';

class SettingNew extends PureComponent {
  state = {};
  componentDidMount = () => {
    this._setting();
  };
  _setting = async () => {
    const { loginId } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
    } else {
      const result = await this._settingApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const settingData = result.data[0].listData;
        //console.log(settingData)
        if (intReturn === 0) {
          this.setState({
            vod: settingData[0].vod,
            download: settingData[0].download,
            autoNext: settingData[0].autoNext,
            autoSkip: settingData[0].autoSkip,
            serviceAlram: settingData[0].serviceAlram,
            eventAlram: settingData[0].eventAlram,
            reservationAlram: settingData[0].reservationAlram,
            player: settingData[0].player,
            wishShare: settingData[0].wishShare,
            quickMenu: settingData[0].quickMenu,
            settingData,
          });
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _settingApi = () => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');

    return axios
      .post(
        apiUrl + '/getSetting',
        {
          params: {
            userid: loginId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._setting();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _close = () => {
    const { setSettingShow } = this.props;
    setSettingShow(false);
  };
  _changeVod = (vod) => {
    this.setState({
      vod: vod,
    });
  };
  _changeDownload = (download) => {
    this.setState({
      download: download,
    });
  };
  render() {
    const {
      settingData,
      vod,
      download,
      autoNext,
      autoSkip,
      serviceAlram,
      eventAlram,
      reservationAlram,
      wishShare,
      quickMenu,
    } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        {settingData ? (
          <div className="detail_layer_pop">
            <div className="detail_view set_view">
              <div className="detail_layer_close" onClick={this._close}>
                <img src={imgUrl + '/img/detail_img/close_1.png'} />
              </div>
              <div className="detail_view_layer">
                <div className="detil_top" id="top">
                  <div className="set_wrap">
                    <h2>환경설정</h2>
                    <div className="set_form">
                      <div className="set">
                        <h3>알림 설정</h3>
                        <SettingItem
                          gubun="service"
                          name={'서비스 알림 받기'}
                          selected={serviceAlram === 'Y' ? true : false}
                        />
                        <SettingItem
                          gubun="event"
                          name={'이벤트 알림 받기'}
                          selected={eventAlram === 'Y' ? true : false}
                        />
                        <SettingItem
                          gubun="reservation"
                          name={'예약 알림 받기'}
                          selected={reservationAlram === 'Y' ? true : false}
                        />
                      </div>
                      <div className="set">
                        <h3>서비스 설정</h3>
                        <SettingItem
                          gubun="quickMenu"
                          name={'퀵메뉴 보기'}
                          selected={quickMenu === 'Y' ? true : false}
                        />
                        <SettingItem
                          gubun="wishShare"
                          name={'내 찜한 작품 친구에게 공유하기'}
                          selected={wishShare === 'Y' ? true : false}
                        />
                      </div>
                      <div className="set">
                        <h3>플레이어 설정</h3>
                        <SettingItem
                          gubun="vod"
                          name={'VOD 화질(' + vod + ')'}
                          selected={vod === '1080P' ? true : false}
                          _changeVod={this._changeVod}
                        />
                        <SettingItem
                          gubun="download"
                          name={'다운로드 화질(' + download + ')'}
                          selected={download === '1080P' ? true : false}
                          _changeDownload={this._changeDownload}
                        />
                        <SettingItem
                          gubun="autoplay"
                          name={'다음화 자동재생'}
                          selected={autoNext === 'Y' ? true : false}
                        />
                        <SettingItem
                          gubun="autoskip"
                          name={'OP/EP 자동스킵'}
                          selected={autoSkip === 'Y' ? true : false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SettingNew));
